var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 507,
    viewBox: "0 0 404 507",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15_147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.9445 492.662C58.2646 510.141 18.5923 487.236 17.3895 450.195L4.47371 52.4509C3.20099 13.2567 45.4864 -12.0805 79.4474 7.52693L443.278 217.584C477.239 237.192 476.439 286.481 441.859 304.976L90.9445 492.662Z",
    fill: "url(#paint0_linear_15_147)",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15_147",
    x: 0.445312,
    y: 0.745605,
    width: 471.832,
    height: 505.89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15_147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15_147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_147",
    x1: 20.0006,
    y1: 530.607,
    x2: 341.817,
    y2: -26.7946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#685296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523958,
    stopColor: "#DCCBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76875,
    stopColor: "#C0A2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon3);
export default __webpack_public_path__ + "static/media/Polygon3.2566dc5787107807f17856a378777dd6.svg";
export { ForwardRef as ReactComponent };